// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import 'babel-polyfill'
import Vue from 'vue'
import App from './App'
import router from './router'
import ElementUI from 'element-ui'
import vuex from 'vuex'
import httpRequest from '@/utils/httpRequest'
import store from './vuex/store.js'
import VueI18n from 'vue-i18n'
import i18n from './i18n/i18n'
import $ from 'jquery'
import 'element-ui/lib/theme-chalk/index.css'
import 'amfe-flexible/index.js'



Vue.use(vuex)


Vue.config.productionTip = false

Vue.use(ElementUI);
Vue.prototype.$baseUrl =  location.protocol + '//' + location.host + '/';
// Vue.prototype.$baseUrl = location.href + '/';

Vue.prototype.$http = httpRequest // ajax请求方法
Vue.use(VueI18n)


Vue.prototype.resetSetItem = function (key, newVal) {
  if (key === 'isHelpView') {
      // 创建一个StorageEvent事件
      var newStorageEvent = document.createEvent('StorageEvent');
      const storage = {
          setItem: function (k, val) {
              sessionStorage.setItem(k, val);
              // 初始化创建的事件
              newStorageEvent.initStorageEvent('setItem', false, false, k, null, val, null, null);
              // 派发对象
              window.dispatchEvent(newStorageEvent)
          }
      }
      return storage.setItem(key, newVal);
  }
}

// function isMobile() {
//   let flag = navigator.userAgent.match(/(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i);
//   return flag;
//  }
// console.log(isMobile());
/* eslint-disable no-new */

const createVue = () => {
  new Vue({
    el: '#app',
    router,
    store,
    i18n,
    components: { App },
    template: '<App/>'
  })
}

httpRequest.accountinfoGeo().then((res) => {
  console.log(res.data.idc, 'res')
  Vue.prototype.$isGlobal = res.data.idc.toLowerCase() !== 'cn';
 createVue()
}).catch(() => {
 createVue()
})


// WEBPACK FOOTER //
// ./src/main.js